import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getTicketOptions } from '../../../services/tickets';
import { ITicketFilterOptions } from '../../../services/tickets/types';

export const ThunkGetTicketsFiltersOptions = createAsyncThunk<ITicketFilterOptions>(
  `${storeResources.TICKETS}/getTicketOptions`,
  () => getTicketOptions().then(res => res.data),
);
